<template>
  <div class="container">
    <h2>报告描述</h2>
    <a-row gap="12">
      <a-form-model ref="formRef" layout="inline" :model="form" :rules="rules">
        <a-col :span="24" class="first-item">
          <a-form-model-item label="大脑学习力分数" prop="studyScore">
            <a-input-number :min="50" :max="150" v-model="form.studyScore" placeholder="请输入大脑学习力分数" style="width: 280px" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" style="margin-bottom: 50px">
          <div style="margin-bottom: 16px">
            <span class="title">单维能力分数：</span>
            <a-button type="primary" @click="openModal()">添加能力</a-button>
          </div>
          <a-table :loading="tableLoading" :columns="columns" rowKey="id" :pagination="false" :data-source="form.abilityScores">
            <template slot="action" slot-scope="text">
              <a-button type="link" @click="openModal(text)">编辑</a-button>
              <a-popconfirm title="确认删除该能力？" @confirm="delAbility(text)">
                <a-button type="link" style="color: red">删除</a-button>
              </a-popconfirm>
            </template>
            <template slot="firstAbitily" slot-scope="text">
              <span>{{ text.abilityType + '/' + text.firstAbitily }}</span>
            </template>
          </a-table>
        </a-col>
        <a-col :span="24" class="title">校级报告描述：</a-col>
        <a-col :span="24">
          <a-form-model-item label="校级报告模板描述" prop="templateDescription">
            <div class="textarea-suffix">
              <a-textarea v-model="form.templateDescription" class="textarea" placeholder="不超过500字" :rows="6" :maxLength="500" style="width: 580px" />
              <span class="input-suffix">
                {{ String(form.templateDescription || '').length + '/' + 500 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" class="title">数据结果描述：</a-col>
        <a-col :span="24">
          <a-form-model-item label="达到模板人数为100%" prop="percent100">
            <div class="textarea-suffix">
              <a-textarea class="textarea" v-model="form.percent100" placeholder="不超过1200字" :rows="6" :maxLength="1200" style="width: 580px" />
              <span class="input-suffix">
                {{ String(form.percent100 || '').length + '/' + 1200 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="达到模板人数为75%-100%" prop="percent75To100">
            <div class="textarea-suffix">
              <a-textarea class="textarea" v-model="form.percent75To100" placeholder="不超过1200字" :rows="6" :maxLength="1200" style="width: 580px" />
              <span class="input-suffix">
                {{ String(form.percent75To100 || '').length + '/' + 1200 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="达到模板人数为25%-75%" prop="percent25To75">
            <div class="textarea-suffix">
              <a-textarea class="textarea" v-model="form.percent25To75" placeholder="不超过1200字" :rows="6" :maxLength="1200" style="width: 580px" />
              <span class="input-suffix">
                {{ String(form.percent25To75 || '').length + '/' + 1200 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="达到模板人数为0%-25%" prop="percent0To25">
            <div class="textarea-suffix">
              <a-textarea  class="textarea" v-model="form.percent0To25" placeholder="不超过1200字" :rows="6" :maxLength="1200" style="width: 580px" />
              <span class="input-suffix">
                {{ String(form.percent0To25 || '').length + '/' + 1200 }}
              </span>
            </div>
          </a-form-model-item>
        </a-col>
      </a-form-model>
    </a-row>
    <a-row class="submit-footer">
      <a-button type="primary" @click="submit">保存</a-button>
    </a-row>
    <a-modal v-model="visible" :title="this.modalForm.id ? '编辑能力' : '添加能力'" width="500px" @ok="modalComfir" @cancel="closeModle">
      <div class="modal-body">
        <a-form-model ref="modalFormRef" :model="modalForm" :labelCol="{ span: 6 }" :wrapperCol="{ span: 12 }">
          <a-form-model-item
            label="能力维度"
            prop="selectName"
            :rules="[
              { required: true, type: 'array', message: '请选择能力维度', trigger: 'change' },
              { trigger: 'blur', validator: validator },
            ]"
          >
            <a-cascader
              v-model="modalForm.selectName"
              :field-names="{ label: 'name', value: 'name', children: 'children' }"
              :options="options"
              :load-data="loadData"
              placeholder="请选择能力维度"
              change-on-select
              @change="onChange"
            />
          </a-form-model-item>
          <a-form-model-item label="能力维度分数" prop="score" :rules="[{ required: true, message: '请输入内容' }]">
            <a-input-number placeholder="请输入能力维度分数" style="width: 100%" v-model="modalForm.score" :max="150" :min="50" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: '',
  inject: ['getTempId'],
  data() {
    return {
      form: {
        studyScore: '',
        percent100: '',
        percent75To100: '',
        percent25To75: '',
        percent0To25: '',
        abilityScores: [],
        templateDescription: '',
        templateResultDescription: '',
      },
      tableLoading: false,
      rules: {
        studyScore: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        percent100: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        percent75To100: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        percent25To75: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        percent0To25: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        templateDescription: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      columns: [
        {
          title: '能力维度',
          scopedSlots: { customRender: 'firstAbitily' },
        },
        {
          title: '能力分数',
          dataIndex: 'score',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      modalForm: {
        selectName: [],
        score: '',
      },
      options: [
        {
          name: '自控力',
        },
        {
          name: '反应力',
        },
        {
          name: '记忆力',
        },
        {
          name: '思维力',
        },
        {
          name: '注意力',
        },
      ],
      includAbility: ['自控力', '反应力', '记忆力', '思维力', '注意力'],
      visible: false,
    }
  },
  created() {
    this._tempId = this.getTempId()
    if (this._tempId) {
      this.getdetail(this._tempId)
    }
  },
  methods: {
    validator(_, value, cb) {
      console.log(value)
      if (value && value.length <= 1) {
        return cb(new Error('请选择能力维度'))
      }

      return cb()
    },
    repeatAbility(value) {
      if (value) {
        const isSome = this.form.abilityScores.some((item) => item.firstAbitily == value.name)
        return isSome
      }
    },
    openModal(record) {
      this.visible = true
      this.modalForm.edit = false
      if (record) {
        this.modalForm.selectName = [record.abilityType, record.firstAbitily]
        this.modalForm.abilityType = record.abilityType
        this.modalForm.edit = true
        this.modalForm.id = record.id
        this.modalForm.score = record.score
      }
      this.abilityTypeSelect()
    },
    onChange(value, e) {
      this.modalForm.selectName = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
            targetOption.loading = false
            targetOption.children = res.data.data
              .filter((v) => this.includAbility.includes(v.name))
              .map((m) => ({ ...m, disabled: this.repeatAbility({ ...m, parentName: targetOption.name }), value: m.id, label: m.name, isLeaf: m.levelNumber > 0 }))
            this.options = [...this.options]
            resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(cb) {
      let params = {
        level: 0,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then(async (res) => {
          this.options = res.data.data.filter((item) => item.name == '基础能力')
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
          if (this.modalForm.selectName.length >= 1) {
            await this.loadData(this.options.filter((f) => f.name === this.modalForm.selectName[0]))
            cb && cb()
        }
      })
    },

    closeModle() {
      this.$refs['modalFormRef'].clearValidate()
      this.visible = false
      this.modalForm = {
        selectName: [],
        score: '',
      }
    },
    delAbility(text) {
      this.form.abilityScores = this.form.abilityScores.filter((item) => item.id != text.id)
    },
    async modalComfir() {
      await this.$refs['modalFormRef'].validate()
      const names = this.modalForm.selectName
      if (this.modalForm.edit) {
        const recordIndex = this.form.abilityScores.findIndex((item) => item.id == this.modalForm.id)
        this.form.abilityScores[recordIndex].updateTime = moment().format('YYYY-MM-DD HH:mm:ss')
        this.form.abilityScores[recordIndex].score = this.modalForm.score
        this.form.abilityScores[recordIndex].abilityType = names[0]
        this.form.abilityScores[recordIndex].firstAbitily = names[1]
        this.form.abilityScores = [...this.form.abilityScores]
      } else {
        this.form.abilityScores.push({
          id: +new Date(),
          firstAbitily: names[1],
          score: this.modalForm.score,
          abilityType: names[0],
          createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          updateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        })
      }

      this.closeModle()
    },
    async getdetail(id) {
      const { data = {} } = await this.$http.GroupReportTemp.detailReportTemp(id)
      this.form = {
        ...data,
      }
      this.form.studyScore = this.form.studyScore || undefined
      this.form.abilityScores = this.form.abilityScores.map((v, i) => ({ ...v, id: i + 1 }))
    },
    async submit() {
      await this.$refs['formRef'].validate()
      const params = {
        ...this.form,
      }
      if (this._tempId) {
        params.id = +this._tempId
      }
      params.abilityScores = params.abilityScores.map((v) => {
        delete v.id
        return v
      })
      await this.$http.GroupReportTemp.editReportTempDesc(params)
      this.$message.success('操作成功')
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  padding: 16px;

  .input-suffix {
    color: #999;
  }
  .textarea-suffix {
    position: relative;
    .textarea {
      padding-bottom: 20px;
    }
    .input-suffix {
      position: absolute;
      right: 10px;
      bottom: -2px;
    }
  }
  .title {
    font-size: 14px;
    color: #000;
    margin-bottom: 20px;
  }

  ::v-deep .ant-form-item {
    margin-bottom: 16px;
    .ant-form-item-label {
      width: 200px;
    }
  }
  .first-item {
    ::v-deep .ant-form-item {
      .ant-form-item-label {
        width: 120px;
      }
    }
  }
  .submit-footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
}
</style>
